import React, { FC, useEffect, useRef, useState } from 'react';
import { addComma } from 'src/utils/common';
import TitleContent from 'src/components/molecules/contentLayout/TitleContent';
import InputBox from 'src/components/atoms/input/DefInputBox';
import IconButton from 'src/components/atoms/buttons/IconButton';

interface Props {
  data: any;
  type?: string;
}
const GridList: FC<Props> = ({ type = '', data }) => {
  // view type
  const [viewType, setViewType] = useState({ view: '' });
  useEffect(() => {
    setViewType({ view: type });
  }, [type]);
  const inpStatus = viewType.view === '' ? '_read' : '';

  const inpChangeEvt = (e: React.ChangeEvent<HTMLInputElement>, key: string) => {};

  const labelStyle = { width: '230px', color: '#777', fontSize: '13px' };
  const boxStyle = { fontSize: '15px', fontWeight: '700' };

  return (
    <div className="_comp_detail_content_div _active">
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'name')}
            label="외국인 기술자 소득세 감면(50%)"
            labelPosition="left"
            value={addComma(data.tred_t01 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r  _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'name')}
            label="외국인 기술자 소득세 감면(70%)"
            labelPosition="left"
            value={addComma(data.tred_t02 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'name')}
            // inputRef={inpRef}
            label="중소기업 취업자 소득세감면(70%)"
            labelPosition="left"
            value={addComma(data.tred_t12 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tred_t13')}
            // inputRef={inpRef}
            label="중소기업 취업자 소득세감면(90%)"
            labelPosition="left"
            value={addComma(data.tred_t13 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tred_t20')}
            // inputRef={inpRef}
            label="조세조약상 교직자 소득세감면"
            labelPosition="left"
            value={addComma(data.tred_t20 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tred_t30')}
            // inputRef={inpRef}
            label="성과공유 중소기업 경영성과급(50%)"
            labelPosition="left"
            value={addComma(data.tred_t30 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tred_t40')}
            // inputRef={inpRef}
            label="중소기업 청년·핵심인력 성과보상기금(50%)"
            labelPosition="left"
            value={addComma(data.tred_t40 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tred_t41')}
            // inputRef={inpRef}
            label="중소기업 청년·핵심인력 성과보상기금(30%)"
            labelPosition="left"
            value={addComma(data.tred_t41 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tred_t42')}
            // inputRef={inpRef}
            label="중소기업 청년·핵심인력 성과보상기금(90%)"
            labelPosition="left"
            value={addComma(data.tred_t42 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tred_t43')}
            // inputRef={inpRef}
            label="중견기업 청년·핵심인력 성과보상기금(50%)"
            labelPosition="left"
            value={addComma(data.tred_t43 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
      <div className="_row">
        <div className="_item _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tred_t50')}
            // inputRef={inpRef}
            label="내국인 우수인력 국내복귀 소득세 감면(50%)"
            labelPosition="left"
            value={addComma(data.tred_t50 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
        <div className="_item_r _half" style={{ zIndex: 10 }}>
          <InputBox
            changeEvt={e => inpChangeEvt(e, 'tred_t00')}
            // inputRef={inpRef}
            label="소득세법"
            labelPosition="left"
            value={addComma(data.tred_t00 || 0)}
            placeholder="급여를 입력하세요"
            labelStyleDef={labelStyle}
            styleDef={{ fontSize: '15px', fontWeight: '700' }}
            status={inpStatus}
            inpStyleDef={{ textAlign: 'right' }}
          />
        </div>
      </div>
    </div>
  );
};

export default GridList;
